import { useState, useEffect } from 'react'
import { parsePeopleAlsoViewed } from '../utils/peopleAlsoViewed.utils'

interface UsePeopleAlsoViewedProps {
  peopleAlsoViewedHtml?: string
  locale: string
  tenant: string
  useStaging?: boolean
}

interface UsePeopleAlsoViewedResult {
  articleNumbers: string[]
  loading: boolean
  error: string | null
}

export function usePeopleAlsoViewed({ peopleAlsoViewedHtml, locale, tenant, useStaging }: UsePeopleAlsoViewedProps): UsePeopleAlsoViewedResult {
  const [articleNumbers, setArticleNumbers] = useState<string[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const hcServiceUrl = useStaging ? 'HELP_CENTER_SERVICE_STAGING' : 'HELP_CENTER_SERVICE'

    if (!peopleAlsoViewedHtml || !hcServiceUrl) {
      setArticleNumbers([])
      return
    }

    const fetchArticleIds = async () => {
      setLoading(true)
      setError(null)

      try {
        const parsedItems = parsePeopleAlsoViewed(peopleAlsoViewedHtml)

        if (parsedItems.length === 0) {
          setArticleNumbers([])
          return
        }

        const parsedArticleNumbers = parsedItems.map((item) => item.articleNumber)
        setArticleNumbers(parsedArticleNumbers)
      } catch (err) {
        console.error('Error processing people also viewed:', err)
        setError(err instanceof Error ? err.message : 'Unknown error occurred')
        setArticleNumbers([])
      } finally {
        setLoading(false)
      }
    }

    fetchArticleIds()
  }, [peopleAlsoViewedHtml, locale, tenant, useStaging])

  return { articleNumbers, loading, error }
}
